// React
import React from 'react';
import * as ReactDOM from 'react-dom/client';

// Vendors
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Src
import createI18n from '@/infrastructure/language/i18n';
import { store, persistor } from '@/infrastructure/redux/configureStore';
import { addMessageAction } from '@/infrastructure/redux/clientState/snackBarReducer';
import { ApiError } from '@/infrastructure/api/core/ApiError';
import App from './App';

// Style
import '@/ui/styles/index.scss';

createI18n();

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});

const AppStrictMode: React.FC = () => (
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate
                loading={null}
                persistor={persistor}
            >
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<AppStrictMode />);
